/**
 * Deterministická variace podle `product.id` (stabilní mezi rendery, žádný layout shift).
 * Vrací celé číslo 0..mod-1. Slouží k jemné ruční variaci karet (glyf, rotace, badge),
 * aby žádné dvě sousední karty nebyly pixelově identické (proposal 003 §3.4).
 */
export function seed(id: number, mod: number): number {
  return Math.abs((id * 2654435761) >> 8) % mod;
}
